import baggingSvg from './svgs/bagging.svg';
import unbaggingSvg from './svgs/unbagging.svg';
import departureSvg from './svgs/departure.svg';
import loadingSvg from './svgs/loading.svg';
import pickupArrivalSvg from './svgs/pickupArrival.svg';
import sealedSvg from './svgs/sealed.svg';
import transferArrivalSvg from './svgs/transferArrival.svg';
import unsealingSvg from './svgs/unsealing.svg';
import whsArrivalSvg from './svgs/whsArrival.svg';
import returnSvg from './svgs/return.svg';
import returnToWhsSvg from './svgs/returnToWhs.svg';
import returnArrivalSvg from './svgs/returnArrival.svg';
import holdingSvg from './svgs/holding.svg';
import sortingSvg from './svgs/sorting.svg';
import trackPackageSvg from './svgs/trackPackage.svg';
import handoverSvg from './svgs/handover.svg';
import weightParcelSvg from './svgs/weightParcel.svg';
import exceptionSvg from './svgs/exception.svg';
import destroySvg from './svgs/destroy.svg';
import shipOutSvg from './svgs/shipOut.svg';
import shipInSvg from './svgs/shipIn.svg';
import putAwaySvg from './svgs/putAway.svg';
import pickingSvg from './svgs/picking.svg';
import cartonScanSvg from './svgs/cartonScan.svg';
import mergeBagSvg from './svgs/mergeBag.svg';

interface IconProps {
    width?: number;
    height?: number;
    className?: string;
}

export const BaggingIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={baggingSvg} width={width} height={height} className={className} alt="Bagging Icon" />
    );
  };

  export const UnbaggingIcon: React.FC<IconProps> = ({
    width = 24,
    height = 24,
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={unbaggingSvg} width={width} height={height} className={className} alt="Unbagging Icon" />
    );
  };

  export const DepartureIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-10 h-10'
  }) => {
    return (
     <img src={departureSvg} width={width} height={height} className={className} alt="Departure Icon" />
    );
  };

  export const LoadingIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={loadingSvg} width={width} height={height} className={className} alt="Loading Icon" />
    );
  };

  export const PickupArrivalIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={pickupArrivalSvg} width={width} height={height} className={className} alt="Pickup Arrival Icon" />
    );
  };

  export const SealedIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={sealedSvg} width={width} height={height} className={className} alt="Sealed Icon" />
    );
  };

  export const TransferArrivalIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={transferArrivalSvg} width={width} height={height} className={className} alt="Transfer Arrival Icon" />
    );
  };

  export const UnsealingIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={unsealingSvg} width={width} height={height} className={className} alt="Unsealing Icon" />
    );
  };

  export const WhsArrivalIcon: React.FC<IconProps> = ({ 
    width = 24, 
    height = 24, 
    className = 'w-8 h-8'
  }) => {
    return (
     <img src={whsArrivalSvg} width={width} height={height} className={className} alt="Whs Arrival Icon" />
    );
  };

  export const ReturnIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
  }) => {
    return (
        <img src={returnSvg} width={width} height={height} className={className} alt="Return Icon" />
    );
  };

  export const ReturnToWhsIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
  }) => {
    return (
        <img src={returnToWhsSvg} width={width} height={height} className={className} alt="Return To WHS Icon" />
    );
  };

  export const ReturnArrivalIcon: React.FC<IconProps> = ({
      width = 24,
      height = 24,
      className = 'w-8 h-8'
    }) => {
    return (
        <img src={returnArrivalSvg} width={width} height={height} className={className} alt="Return Arrival Icon" />
    );
  };

  export const HoldingIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={holdingSvg} width={width} height={height} className={className} alt="Holding Icon" />
    );
  };

  export const SortingIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={sortingSvg} width={width} height={height} className={className} alt="Sorting Icon" />
    );
  };

  export const TrackPackageIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={trackPackageSvg} width={width} height={height} className={className} alt="Track Package Icon" />
    );
  };

  export const HandoverIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={handoverSvg} width={width} height={height} className={className} alt="Handover Icon" />
    );
  };

  export const WeightParcelIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={weightParcelSvg} width={width} height={height} className={className} alt="Weight Parcel Icon" />
    );
  };

  export const ExceptionIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={exceptionSvg} width={width} height={height} className={className} alt="Exception Icon" />
    );
  };

  export const DestroyIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={destroySvg} width={width} height={height} className={className} alt="Destroy Icon" />
    );
  };

  export const ShipOutIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={shipOutSvg} width={width} height={height} className={className} alt="Ship Out Icon" />
    );
  };

  export const ShipInIcon: React.FC<IconProps> = ({
     width = 24,
     height = 24,
     className = 'w-8 h-8'
   }) => {
    return (
        <img src={shipInSvg} width={width} height={height} className={className} alt="Ship In Icon" />
    );
  };

  export const PutAwayIcon: React.FC<IconProps> = ({
                                                       width = 24,
                                                       height = 24,
                                                       className = 'w-8 h-8'
                                                   }) => {
    return (
        <img src={putAwaySvg} width={width} height={height} className={className} alt="Put Away Icon" />
    );
};

  export const CartonScanIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className = 'w-8 h-8'
                                                 }) => {
    return (
        <img src={cartonScanSvg} width={width} height={height} className={className} alt="Carton Scan Icon" />
    );
};

  export const BagMergeIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className = 'w-8 h-8'
                                                 }) => {
    return (
        <img src={mergeBagSvg} width={width} height={height} className={className} alt="Bag Merge Icon" />
    );
};

  export const PickingIcon: React.FC<IconProps> = ({
                                                     width = 24,
                                                     height = 24,
                                                     className = 'w-8 h-8'
                                                 }) => {
    return (
        <img src={pickingSvg} width={width} height={height} className={className} alt="Picking Icon" />
    );
};